function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M224.42,284.59l-32.28-53.71,38.74-38.74,53.71,32.28v.08a145.69,145.69,0,0,1,32.87-13.69L332.61,150h54.78l15.16,60.81a145.69,145.69,0,0,1,32.87,13.69v-.08l53.71-32.28,38.74,38.74-32.28,53.71h-.08a145.69,145.69,0,0,1,13.69,32.87L570,332.61v54.78l-60.81,15.16a145.69,145.69,0,0,1-13.69,32.87h.08l32.28,53.71-38.74,38.74-53.71-32.28v-.08a145.69,145.69,0,0,1-32.87,13.69L387.39,570H332.61l-15.16-60.81a145.69,145.69,0,0,1-32.87-13.69v.08l-53.71,32.28-38.74-38.74,32.28-53.71h.08a145.69,145.69,0,0,1-13.69-32.87L150,387.39V332.61l60.81-15.16a145.69,145.69,0,0,1,13.69-32.87Z",
    style: {
      fill: "none",
      stroke: "#2f2f30",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 360,
    r: 82.17,
    style: {
      fill: "none",
      stroke: "#2f2f30",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 26
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 720,
    style: {
      fill: "none"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.7becca10eb928273a5b732b7daf90e8b.svg";
export { ForwardRef as ReactComponent };